import { StyleSheet } from 'react-native'
import { Theme } from '@theme'

export const getDetailProfileStyle = (theme: Theme) =>
  StyleSheet.create({
    contentContainer: {
      paddingBottom: theme.spacing.lg,
    },
    content: {
      flex: 1,
    },
    rightSection: {
      flexDirection: 'row',
      alignSelf: 'flex-end',
      alignItems: 'center',
      gap: theme.spacing.sm,
      marginRight: theme.spacing.lg,
      height: theme.spacing.xxxl,
    },
    menuButton: {
      padding: theme.spacing.xs,
    },
    infoContainer: {
      flexDirection: 'row',
      alignItems: 'flex-end',
      gap: 15,
      paddingHorizontal: theme.spacing.md,
    },
    infoTextContainer: {
      flex: 1,
    },
    titleContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      marginBottom: theme.spacing.xs,
      marginTop: theme.spacing.xxl,
    },
    titleContainerExtension: {
      marginTop: theme.spacing.xl,
    },
    name: {
      flex: 1,
      textAlign: 'left',
    },
    locationContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      flexShrink: 1,
    },
    locationText: {
      marginLeft: theme.spacing.xs,
      flexShrink: 1,
    },
    work: {
      marginBottom: theme.spacing.xs,
    },
    row: {
      flexDirection: 'row',
      alignItems: 'center',
      flexWrap: 'wrap',
      columnGap: 20,
      rowGap: theme.spacing.xs,
    },
    actionButtonsContainer: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-around',
      paddingHorizontal: theme.spacing.lg,
      marginBottom: theme.spacing.lg,
    },
    container: {
      marginHorizontal: theme.spacing.lg,
      paddingVertical: theme.spacing.xl,
      borderWidth: 1,
      borderColor: theme.colors.grey,
      borderRadius: theme.border.jumbo,
    },
    floatingPanel: {
      position: 'absolute',
      right: theme.spacing.lg,
      bottom: theme.spacing.xl,
      alignItems: 'center',
    },
    floatingContent: {
      alignItems: 'center',
      gap: theme.spacing.sm,
      marginBottom: theme.spacing.sm,
    },
    floatingDeleteButton: {
      width: 44,
      height: 44,
      borderRadius: 22,
      borderWidth: 1,
      borderColor: theme.colors.error,
      backgroundColor: theme.colors.white,
      justifyContent: 'center',
      alignItems: 'center',
    },
    floatingToggle: {
      backgroundColor: theme.colors.white,
      borderRadius: 999,
      padding: theme.spacing.sm,
      shadowColor: '#000',
      shadowOpacity: 0.12,
      shadowRadius: 8,
      shadowOffset: { width: 0, height: 2 },
      elevation: 4,
    },
  })
